<script>
  import Image from "../Image.svelte";
  export let block;

  $: image = (() => {
    if (!block.primary.ultrawide) return block.primary.hero;
    const ultrawide = Object.fromEntries(
      Object.entries(block.primary.hero)
        .filter(([key]) => key.indexOf("ultrawide-") === 0)
        .map(([key, value]) => [key.replace("ultrawide-", ""), value]),
    );
    return {
      ...ultrawide,
      ...ultrawide.main,
    };
  })();
</script>

<div class="hero bg-follow">
  <Image {image} />
</div>
